<div class="col-md-12" *ngIf="loader">

  <p-skeleton styleClass="mb-2"></p-skeleton>

</div>
<!--class="card "-->
<div style="padding:7px">

  <div class="row ">
    <!--*ngIf="showInternetChart"-->
    <div class="col-6  " id="internetchart" *ngIf="showInternetChart" style="width:100%"></div>
    <div class="col-6 " id="datachart" *ngIf="showDataChart" style="width:100%"></div>
    <div class="overlay dark" *ngIf="loader" style="width:100%">
      <i class="fas fa-2x fa-sync-alt fa-spin"></i>
    </div>
  </div>
</div>
